import { createSelector } from 'reselect'
import { User } from 'types/User'
import { getUser } from './helpers'

export const getIsInitialLoadReady = createSelector(
  [getUser],
  (user: User): boolean => user.isInitialLoadReady
)
